import { useContext, useEffect, useState } from 'react';
import { OrderProviderValue, ProductItemModel, RaffleCountDownModel, UserProviderValue } from '../models';
import { ProductItemTypes } from '../enums';
import { getRaffleCountdownText } from '../utils';
import { OrderContext } from '../contexts/order.context';
import { UserContext } from '../contexts/user.context';
import { useCountryContext } from '../contexts/country.context';
import { toast } from 'react-toastify';

export const useProductItem = (productItem: ProductItemModel) => {
   const { placeOrder, isLoading } = useContext<OrderProviderValue>(OrderContext);
   const { user, isAuthenticated } = useContext<UserProviderValue>(UserContext);
   const { countries, isSweepstakeCountryAllowed } = useCountryContext();

   const [raffleCountdown, setRaffleCountdown] = useState<RaffleCountDownModel | null>(null);
   const [inspect, setInspect] = useState(false);
   const [showDetails, setShowDetails] = useState(false);
   const [addToCartQuantity, setAddToCartQuantity] = useState(0);

   const [tosAccepted, setTosAccepted] = useState(false);

   useEffect(() => {
      if (productItem.type !== ProductItemTypes.RAFFLE) return;

      setRaffleCountdown(getRaffleCountdownText(productItem.startsAt ? new Date(productItem.startsAt) : null, productItem.endsAt ? new Date(productItem.endsAt) : null));

      setTosAccepted(productItem.userEntries > 0);

      const interval = setInterval(() => {
         setRaffleCountdown(getRaffleCountdownText(productItem.startsAt ? new Date(productItem.startsAt) : null, productItem.endsAt ? new Date(productItem.endsAt) : null));
      }, 10000);

      return () => clearInterval(interval);
   }, [productItem]);

   useEffect(() => {
      if (!inspect) {
         setShowDetails(false);
         return;
      }
   }, [inspect]);

   const confirmEntries = async (): Promise<any> => {
      if (!tosAccepted) return;

      // Validate country before purchase
      const hasValidCountry = user?.country && countries.find((c) => c.value === user.country);
      if (!hasValidCountry) {
         toast.error('Please select your country to purchase sweepstakes entries');
         return;
      }

      if (!isSweepstakeCountryAllowed(user.country)) {
         toast.error('Sweepstakes purchases are not available in your country');
         return;
      }

      await placeOrder(productItem, addToCartQuantity);
      setInspect(false);

      setAddToCartQuantity(0);
   };

   return {
      raffleCountdown,
      inspect,
      setInspect,
      showDetails,
      setShowDetails,
      confirmEntries,
      addToCartQuantity,
      setAddToCartQuantity,
      isLoading,
      isAuthenticated,
      tosAccepted,
      setTosAccepted,
   };
};
